import Regimens from '../../../../components/Regimens'
import { DentalRegimensProps } from '../utils/types'

export const DentalRegimens = ({ lists }: DentalRegimensProps) => {
  return <Regimens recordLabel='Dental' lists={lists} />
}
